import { Satellite } from '../types/satellite'
// This function simulates fetching satellite data from an API
// In a real application, this would connect to a real satellite database
export const fetchSatelliteData = async (): Promise<Satellite[]> => {
  // Simulate API delay
  await new Promise((resolve) => setTimeout(resolve, 1000))
  // Generate mock satellite data
  const mockSatellites: Satellite[] = []
  const countries = [
    'USA',
    'Russia',
    'China',
    'EU',
    'Japan',
    'India',
    'UK',
    'Canada',
    'Brazil',
    'Israel',
  ]
  const purposes = [
    'Communication',
    'Navigation',
    'Earth Observation',
    'Military',
    'Scientific Research',
    'Technology Demonstration',
  ]
  const technologies = [
    'Optical',
    'Radar',
    'Radio',
    'Infrared',
    'Multispectral',
    'Hyperspectral',
    'GPS',
    'GLONASS',
    'Galileo',
  ]
  // Generate 300 satellites with random properties
  for (let i = 0; i < 300; i++) {
    const country = countries[Math.floor(Math.random() * countries.length)]
    const purpose = purposes[Math.floor(Math.random() * purposes.length)]
    const technology =
      technologies[Math.floor(Math.random() * technologies.length)]
    const launchYear = Math.floor(Math.random() * (2023 - 1957 + 1)) + 1957
    // Calculate altitude in km (LEO, MEO, GEO)
    let altitude
    const orbitType = Math.random()
    if (orbitType < 0.6) {
      // Low Earth Orbit (LEO): 160-2000 km
      altitude = Math.floor(Math.random() * (2000 - 160 + 1)) + 160
    } else if (orbitType < 0.9) {
      // Medium Earth Orbit (MEO): 2000-35786 km
      altitude = Math.floor(Math.random() * (35786 - 2000 + 1)) + 2000
    } else {
      // Geostationary Orbit (GEO): ~35786 km
      altitude = 35786 + Math.floor(Math.random() * 100)
    }
    mockSatellites.push({
      id: `sat-${i}`,
      name: `Satellite-${i}`,
      country,
      purpose,
      technology,
      launchYear,
      altitude,
      // These would be real orbital parameters in a real application
      inclination: Math.random() * 180,
      eccentricity: Math.random() * 0.1,
      period: Math.floor(Math.random() * 1440) + 90, // minutes
    })
  }
  return mockSatellites
}
